import styled from '@emotion/styled';
import { Modal, Button } from '@mantine/core';
import { useEffect, useState } from 'react';
import { HARDCODED_VALUES } from '../hardcoded-values';

const NoticeContent = styled.div`
    font-family: "Work Sans", sans-serif;
    padding: 1.5rem;
    
    h2 {
        font-size: 1.8rem;
        font-weight: 700;
        background: linear-gradient(45deg, #ff4444, #ff6b35);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-bottom: 1.5rem;
        display: flex;
        align-items: center;
        gap: 0.75rem;
        justify-content: center;
    }
    
    p {
        line-height: 1.8;
        margin-bottom: 1.25rem;
        color: #e8e8e8;
        font-size: 1.05rem;
        text-align: center;
    }
    
    .highlight {
        background: linear-gradient(135deg, rgba(255, 68, 68, 0.15), rgba(255, 107, 53, 0.15));
        border-left: 3px solid #ff4444;
        padding: 1rem 1.25rem;
        border-radius: 0.5rem;
        margin: 1.5rem 0;
        font-weight: 500;
        color: #ffb3b3;
    }
    
    .discord-button {
        margin-top: 1.5rem;
        width: 100%;
        height: 3rem;
        font-size: 1.1rem;
        background: linear-gradient(45deg, #ff4444, #ff6b35);
        border: none;
        font-weight: 600;
        transition: all 0.3s ease;
        
        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(255, 68, 68, 0.4);
            background: linear-gradient(45deg, #ff6b35, #ff4444);
        }
    }
`;

export function DiscordCompromiseNotice() {
    const [opened, setOpened] = useState(false);

    useEffect(() => {
        // Check if notice has been shown this session (not across page reloads)
        const hasSeenThisSession = sessionStorage.getItem('discord-notice-shown');
        
        if (!hasSeenThisSession) {
            // Show notice after a brief delay so the page can load
            setTimeout(() => setOpened(true), 500);
            // Mark as shown for this session only (cleared on page refresh/new tab)
            sessionStorage.setItem('discord-notice-shown', 'true');
        }
    }, []);

    const handleClose = () => {
        setOpened(false);
    };

    const handleJoinDiscord = () => {
        window.open(HARDCODED_VALUES.discord.inviteLink, '_blank', 'noopener,noreferrer');
        handleClose();
    };

    return (
        <Modal
            opened={opened}
            onClose={handleClose}
            title={null}
            centered
            size="lg"
            styles={{
                modal: {
                    backgroundColor: '#303038',
                    border: '2px solid #ff4444',
                    boxShadow: '0 10px 40px rgba(255, 68, 68, 0.3)',
                },
                header: {
                    backgroundColor: 'transparent',
                },
                close: {
                    color: 'white',
                    '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    },
                },
            }}
        >
            <NoticeContent>
                <h2>
                    ⚠️ Urgent Notice
                </h2>
                <p>
                    Our Discord server has been terminated.
                </p>
                <div className="highlight">
                    Please join our new Discord server to stay connected with the community 
                    and continue receiving updates and support!
                </div>
                <p>
                    We apologize for any inconvenience. See you in the new server!
                </p>
                <Button 
                    fullWidth 
                    className="discord-button"
                    onClick={handleJoinDiscord}
                    leftIcon={<i className="fab fa-discord" style={{ fontSize: '1.3rem' }} />}
                >
                    Join New Discord Server
                </Button>
                <Button 
                    fullWidth 
                    variant="subtle" 
                    onClick={handleClose}
                    style={{ marginTop: '0.75rem' }}
                >
                    Maybe Later
                </Button>
            </NoticeContent>
        </Modal>
    );
}

